<div class="row p-4">
    <div class="col-md-12 text-center">
        <h3>{{appName}}</h3>
        <h4>Session Timed Out</h4>
    </div>
</div>
<div class="row mb-4">
    <div class="col-md-12">
        <div class="card">
            <div class="card-body">
                <div class="text-center">
                    <p class="errorMsg font-weight-bold">{{errormsg}}  Click <a href="{{startPage}}" class="undln" >here</a> to restart your process from the initial start page.</p>
                    <h3>Please contact us for further assistance at</h3>
                    <p><i class="fa fa-envelope"></i><a href="mailto:Finance.CustomerService@lacity.org" class="undln"> Finance.CustomerService@lacity.org</a></p>
                    <p>or</p>
                    <p><i class="fa fa-phone"></i> Call 1-844-663-4411 during weekday business hours.</p>   
                </div>
            </div>
        </div>
    </div>
</div>

